import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";

export { Article20ThemeSignUpButtonDisplay } from "./article-20-theme-sign-up-button-display";
export { Article20ThemeSummary } from "./article-20-theme-summary";
export { Article20ThemeTitle } from "./article-20-theme-title";
export * from "./hooks";

export const Article20Theme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

Article20Theme.displayName = "Article20Theme";
